import React from "react";

const iconProps = {
	width: 18,
	height: 18,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": true,
};

export const ProfileNavIcons = {
	settings: (
		<svg {...iconProps}>
			<circle
				cx="12"
				cy="8"
				r="4"
			/>
			<path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
		</svg>
	),
	inbox: (
		<svg {...iconProps}>
			<path d="M4 6h16v12H4z" />
			<path d="M4 10l8 5 8-5" />
		</svg>
	),
	history: (
		<svg {...iconProps}>
			<circle
				cx="12"
				cy="12"
				r="9"
			/>
			<path d="M12 7v5l3 3" />
		</svg>
	),
	documents: (
		<svg {...iconProps}>
			<rect
				x="4"
				y="3"
				width="16"
				height="18"
				rx="2"
			/>
			<path d="M8 8h8M8 12h8M8 16h5" />
		</svg>
	),
	bonuses: (
		<svg {...iconProps}>
			<rect
				x="3"
				y="8"
				width="18"
				height="12"
				rx="2"
			/>
			<path d="M12 8V4M8 4h8" />
		</svg>
	),
	cashback: (
		<svg {...iconProps}>
			<circle
				cx="12"
				cy="12"
				r="9"
			/>
			<path d="M12 7v10M9 10h4a2 2 0 100 4h-2" />
		</svg>
	),
	deposit: (
		<svg {...iconProps}>
			<path d="M12 3v18M5 10l7-7 7 7" />
		</svg>
	),
	withdraw: (
		<svg {...iconProps}>
			<path d="M12 21V3M5 14l7 7 7-7" />
		</svg>
	),
	promoCode: (
		<svg {...iconProps}>
			<path d="M15 5v2M15 11v2M15 17v2M5 5h14a2 2 0 012 2v3a2 2 0 000 4v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-3a2 2 0 000-4V7a2 2 0 012-2z" />
		</svg>
	),
};
